export default class AuthService {
  private static instance: AuthService;
  private getAccessTokenSilentlyFunction?: () => Promise<string>;

  public static getInstance() {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public setAccessTokenSilentlyFunction(func: () => Promise<string>) {
    this.getAccessTokenSilentlyFunction = func;
  }

  public async getUserAccessToken() {
    if (this.getAccessTokenSilentlyFunction) {
      return await this.getAccessTokenSilentlyFunction();
    }
    return null;
  }
}
